
import { Injectable } from '@angular/core';
import { Events } from 'ionic-angular';
import { OptionsOpenPage } from '../../bloc/feature/home/home.dto';
import { EventLabel } from '../../helpers/event-label';

@Injectable()
export class NavigationService {

  constructor(
    private events: Events
  ) { }

  push(page: string, params?: any, onDidDismiss = false) {
    return this.openPage(page, params, 'push', onDidDismiss);
  }

  setRoot(page: string, params?: any, onDidDismiss = false) {
    return this.openPage(page, params, 'setRoot', onDidDismiss);
  }

  onDidDismiss(event) {
    return new Promise((resolve) => {
      this.events.unsubscribe(event);
      this.events.subscribe(event, data => {
        resolve(data);
      });
    })
  }

  openPage(page: string, params?: any, type: 'push' | 'setRoot' = 'push', onDidDismiss = false) {
    const options: OptionsOpenPage = {
      pageStatic: page,
      typeMenu: type,
      params: params,
      onDidDismiss: onDidDismiss
    }

    this.events.publish(EventLabel.OPEN_PAGE, options);
  }
}





// WEBPACK FOOTER //
// ./src/providers/navigation/navigation.ts